import { IColumn } from "us.common/components";

export enum PostalAreasTableColumns {
  MENU = "more",
  POSTAL_CODE = "postalCode",
  POSTAL_PLACE = "postalPlace",
  COUNTY_CODE = "countyCode",
  COUNTY_NAME = "countyName",
  COUNTRY_CODE = "countryCode",
  COUNTRY = "country",
}

export const postalAreasTableColumns: any[] = [
  {
    id: 1,
    key: PostalAreasTableColumns.MENU,
    title: "",
    width: 50,
    align: "center",
  },
  {
    id: 2,
    key: PostalAreasTableColumns.POSTAL_CODE,
    title: "POSTAL_CODE",
    sorter: true,
    customFilter: true,
    width: 120,
  },
  {
    id: 3,
    key: PostalAreasTableColumns.POSTAL_PLACE,
    title: "POSTAL_PLACE",
    sorter: true,
    customFilter: true,
    width: 200,
  },
  {
    id: 4,
    key: PostalAreasTableColumns.COUNTY_CODE,
    title: "MUNICIPALITY_CODE",
    sorter: true,
    customFilter: true,
    width: 150,
  },
  {
    id: 5,
    key: PostalAreasTableColumns.COUNTY_NAME,
    title: "MUNICIPALITY_NAME",
    sorter: true,
    customFilter: true,
    width: 200,
  },
  {
    id: 6,
    key: PostalAreasTableColumns.COUNTRY_CODE,
    title: "COUNTRY_CODE",
    sorter: true,
    customFilter: true,
    width: 120,
  },
  {
    id: 7,
    key: PostalAreasTableColumns.COUNTRY,
    title: "COUNTRY",
    sorter: true,
    customFilter: true,
    width: 150,
  },
];

export const DEFAULT_TABLE_INFO = {
  filters: [],
  sorter: { columnKey: "", order: "" },
  data: [],
};

export const DEFAULT_COLUMN_FILTERS = {
  postalCode: "",
  postalPlace: "",
  countyCode: "",
  countyName: "",
  countryCode: "",
  country: "",
};

export enum DrawerTypes {
  POSTAL_AREA_ADD = "AddNew",
  POSTAL_AREA_EDIT = "Edit",
  POSTAL_AREA_VIEW = "View",
}

export const ITEM_MENU_DEFAULT_STATE = {
  visible: false,
  id: -1,
  visibleTooltip: false,
};
